module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<footer>\r\n    <div class="top">\r\n        <div class="container">\r\n            <a href="index.html">\r\n                <img src="' +
((__t = ( require('./images/footer-logo.png') )) == null ? '' : __t) +
'" alt="">\r\n            </a>\r\n            <div class="ewm">\r\n                <p>关注我们</p>\r\n                <img src="' +
((__t = ( require('./images/footer-ewm.png') )) == null ? '' : __t) +
'" alt="">\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class="bottom">\r\n        <div class="container">\r\n            <div class="left">\r\n                <a href="javascript:;">Copyright © 2024 湖南新联益国际贸易有限公司 All rights reserved 湘ICP备20010999号</a>\r\n                <a href="javascript:;">网站建设  |  东八区创意</a>\r\n            </div>\r\n            <div class="right">\r\n                <a href="javascript:;">\r\n                    <img src="' +
((__t = ( require('./images/footer-icon1.png') )) == null ? '' : __t) +
'" alt="" class="img1">\r\n                    <img src="' +
((__t = ( require('./images/footer-icon1a.png') )) == null ? '' : __t) +
'" alt="" class="img2">\r\n                </a>\r\n                <a href="javascript:;">\r\n                    <img src="' +
((__t = ( require('./images/footer-icon2.png') )) == null ? '' : __t) +
'" alt="" class="img1">\r\n                    <img src="' +
((__t = ( require('./images/footer-icon2a.png') )) == null ? '' : __t) +
'" alt="" class="img2">\r\n                </a>\r\n                <a href="javascript:;">\r\n                    <img src="' +
((__t = ( require('./images/footer-icon3.png') )) == null ? '' : __t) +
'" alt="" class="img1">\r\n                    <img src="' +
((__t = ( require('./images/footer-icon3a.png') )) == null ? '' : __t) +
'" alt="" class="img2">\r\n                </a>\r\n                <a href="javascript:;">\r\n                    <img src="' +
((__t = ( require('./images/footer-icon4.png') )) == null ? '' : __t) +
'" alt="" class="img1">\r\n                    <img src="' +
((__t = ( require('./images/footer-icon4a.png') )) == null ? '' : __t) +
'" alt="" class="img2">\r\n                </a>\r\n                <a href="javascript:;">\r\n                    <img src="' +
((__t = ( require('./images/footer-icon5.png') )) == null ? '' : __t) +
'" alt="" class="img1">\r\n                    <img src="' +
((__t = ( require('./images/footer-icon5a.png') )) == null ? '' : __t) +
'" alt="" class="img2">\r\n                </a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</footer>';

}
return __p
}